import { Button } from 'antd';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
const { setEnvPrefix } = ssCommonUtils;

export default class Footer extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { status, successCallback, failureCallback } = this.props;
        return status === 'pending' ? null : (
            <div className='ss-cmpts-reg-footer'>
                {status === 'pending' || status === 'success' ? (
                    <Button
                        size='small'
                        icon='home'
                        style={{ width: '150px', borderRadius: '40px' }}
                        onClick={() => {
                            if (successCallback) successCallback(status);
                            window.location.href = setEnvPrefix('/home');
                        }}
                    >
                        {'Home'}
                    </Button>
                ) : (
                    <Button
                        size='small'
                        icon='close-circle'
                        style={{ width: '150px', borderRadius: '40px' }}
                        onClick={() => {
                            if (failureCallback) failureCallback(status);
                        }}
                    >
                        {'Close'}
                    </Button>
                )}
            </div>
        )
    }
}